import React from 'react';
import { useSelector } from 'react-redux';

import FormTitle from 'components/PageLayout/FormTitle';
import { Button } from 'components/curo-components/common/Button';
import { CuroApplicationVariables } from 'enums/curo/Variables';
import { getApplicationSelector } from 'handlers/curo-handlers/selectors';
import styled from 'types/AppTheme';

import styles from './EndPages.module.scss';
import { CALL_US_BUTTON_TEXT } from './constants';


const StyledLink = styled.a`
  color: inherit;
`;
const PAGE_TITLE = 'Thank you for your application';

const getAddressLink = (branchStreet: string, branchCityStateZip: string) => {
  const encodedAddressStreet = encodeURIComponent([branchStreet, branchCityStateZip].join(' '));
  const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodedAddressStreet}`;

  return (
    <StyledLink
      target="_blank"
      href={mapsUrl}
      rel="noopener noreferrer"
    >
      {branchStreet}
      <br />
      {branchCityStateZip}
    </StyledLink>
  );
}

const getPageDescription = (phone: string, branchStreet: string, branchCityStateZip: string) => (
  <p className={styles.descriptionWrapper}>
    Great News! You recently received a check from us in the mail and deposited it.
    <br />
    <br />
    Do you still need more money? You may qualify for more. Please visit your branch and a team member can help.
    <br />
    <br />
    Can’t wait to talk? You can call us right now!
    <br />
    <strong>{phone}</strong>
    <br />
    <strong>{getAddressLink(branchStreet, branchCityStateZip)}</strong>
  </p>
);

const ApplicationRefiScorePage = () => {
  const application = useSelector(getApplicationSelector);

  const branchPhone = application?.variables[CuroApplicationVariables.SnowflakeBorrowerBranchPhone] as string;
  const branchStreet = application?.variables[CuroApplicationVariables.BranchStreet] as string;
  const branchCityStateZip = application?.variables[CuroApplicationVariables.BranchCityStateZip] as string;

  const callByPhone = () => {
    window.open(`tel:${branchPhone}`, '_self');
  };

  return (
    <>
      <FormTitle title={PAGE_TITLE} subTitle={getPageDescription(branchPhone, branchStreet || '', branchCityStateZip || '')} />
      <Button onClick={callByPhone} kind="primary" size="form">
        {CALL_US_BUTTON_TEXT}
      </Button>
    </>
  );
};

export default ApplicationRefiScorePage;
